/** fileName: IModal.js
 * developer: majid.garavand@gmail.com
 * created: 3/17/23
 * note: Do not delete this comment to maintain copyright rules
 * */
import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Grid from "@mui/material/Grid";
import CloseIcon from "@mui/icons-material/Close";
import Backdrop from "@mui/material/Backdrop";
import Divider from "@mui/material/Divider";
import {Fade} from "./ModalAnimation";


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};


const IModal = ({
                    open,
                    handleClose = () => {
                        console.log('handle close')
                    },
                    headerItems = null,
                    showClose = false,
                    keepMounted = false,
                    width = 600,
                    height = "auto",
                    borderRadius = '20px',
                    overflow = 'scroll',
                    maxHeight = '90%',
                    maxWidth = '90%',
                    children,
                    SnapToBottom = false,
                    sx = null
                }) => {

    maxWidth = SnapToBottom ? '96%' : maxWidth;
    let y = SnapToBottom ? '0' : '-50%';
    let top = SnapToBottom ? 'unset' : '50%';
    let left = SnapToBottom ? '0' : 'unset';
    let right = '50%';
    let bottom = SnapToBottom ? '0' : 'unset';
    borderRadius = SnapToBottom ? '20px 20px 0 0' : borderRadius;
    // width = SnapToBottom ? '100%' : width;

    const style = {
        position: 'absolute',
        top: top,
        right: right,
        bottom: bottom,
        left: left,
        transform: `translate(50%, ${y}) !important`,
        bgcolor: 'background.paper',
        outline: 'none',
        width: width,
        maxWidth: maxWidth,
        maxHeight: maxHeight,
        border: '1px #7c7c7c #000',
        boxShadow: 24,
        borderRadius: borderRadius,
        padding: '4px 8px',
        textAlign: 'center',
        height: height,
        display: 'flex',
        flexDirection: 'column',
        ...sx
    };

    open = Boolean(open)
    return (

        <Modal
            dir={'rtl'}
            open={open}
            keepMounted={keepMounted}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            closeAfterTransition
            slots={{backdrop: Backdrop}}
            slotProps={{
                backdrop: {
                    TransitionComponent: Fade,
                },
            }}
            sx={{zIndex: 1302}}
        >
            <Fade in={open}>
                <Box sx={style}>

                    {
                        (showClose || headerItems) &&
                        <>
                            <Grid sx={{
                                width: '100%',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                flexDirection: 'row-reverse',
                                backgroundColor: 'inherit',
                                height: '42px',
                                color: '#9d9a9a',
                                top: 0,
                                position: 'sticky',
                                zIndex: 322
                            }}>
                                {
                                    showClose &&
                                    <CloseIcon sx={{cursor: 'pointer'}} onClick={handleClose} color={'error'}/>
                                }
                                {headerItems}
                            </Grid>
                            <Divider/>
                        </>
                    }
                    <Grid sx={{flexGrow: 1, overflowY: overflow}}>
                        {children}
                    </Grid>
                </Box>
            </Fade>
        </Modal>

    )
}
export default IModal
